import { useCallback, useMemo } from 'react'

// TODO: eliminate v1 dependency (requires async initialization of i18next lib)
// V1 import
import { useFormatMessage } from 'lib/localization'

export const useI18n = (baseKey?: string) => {
  const formatMessage = useFormatMessage('ess.v2')

  const customT = useCallback(
    (key: string | undefined, data?: Record<string, string | number>) => {
      if (!key) {
        return ''
      }

      const fullKey = baseKey ? `${baseKey}.${key}` : key
      const text = formatMessage(fullKey, data as any) as unknown as string
      return text || ''
    },
    [baseKey, formatMessage]
  )

  return useMemo(
    () => ({
      t: customT
    }),
    [customT]
  )
}
